"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePlayerBackofficeStore = void 0;
const mobx_1 = require("mobx");
class PlayerBackofficeStore {
    constructor() {
        this.search = '';
        this.selectedMedia = {};
        this.replaceMediaId = null;
        this.openModal = ({ replaceMediaId = null } = {}) => {
            this.replaceMediaId = replaceMediaId;
        };
        this.closeModal = () => {
            this.replaceMediaId = null;
            this.selectedMedia = {};
        };
        this.selectMedia = (media) => {
            this.selectedMedia = media;
        };
        this.deselectMedia = () => {
            this.selectedMedia = {};
        };
    }
}
__decorate([
    mobx_1.observable
], PlayerBackofficeStore.prototype, "search", void 0);
__decorate([
    mobx_1.observable
], PlayerBackofficeStore.prototype, "selectedMedia", void 0);
__decorate([
    mobx_1.observable
], PlayerBackofficeStore.prototype, "replaceMediaId", void 0);
__decorate([
    mobx_1.action
], PlayerBackofficeStore.prototype, "openModal", void 0);
__decorate([
    mobx_1.action
], PlayerBackofficeStore.prototype, "closeModal", void 0);
__decorate([
    mobx_1.action
], PlayerBackofficeStore.prototype, "selectMedia", void 0);
__decorate([
    mobx_1.action
], PlayerBackofficeStore.prototype, "deselectMedia", void 0);
const makePlayerBackofficeStore = () => new PlayerBackofficeStore();
exports.makePlayerBackofficeStore = makePlayerBackofficeStore;
exports.default = (0, exports.makePlayerBackofficeStore)();
